var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.help}},[_c('b-icon-question-circle',{staticClass:"help-icon"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }